import { displayError, displayWarning } from "../../utils/messageToast";
import { displaySuccess } from "../../utils/messageToast";
import { SetupFlowRC } from "../../apis/apisFlowRCByAuthorizationRA_Authorization";

export const tabulateTickets = async (
  tabId: string,
  setTabId: React.Dispatch<React.SetStateAction<string>>,
  ambient: string,
  authorization: string,
  authorizationRA: string,
  setTextAreaValue: React.Dispatch<React.SetStateAction<any>>,
  publicNote: string,
  setPublicNote: React.Dispatch<React.SetStateAction<string>>,
  privateNote: string,
  setPrivateNote: React.Dispatch<React.SetStateAction<string>>,
  protocols: any[],
  setProtocols: React.Dispatch<React.SetStateAction<any[]>>,
  serIsErrors: React.Dispatch<React.SetStateAction<boolean>>,
  setErrors: React.Dispatch<React.SetStateAction<any[]>>,
  signOut: () => void
) => {
  try {
    const apiClient = SetupFlowRC(authorizationRA, authorization);
    const response = await apiClient.post(
      `/tabulation-ticket?ambient=${ambient}&tabId=${tabId}`,
      {
        text: protocols,
        publicNote,
        privateNote,
      }
    );

    if (response.data.errors.length > 0) {
      displayWarning("Alguns tickets não foram tabulados!");
      serIsErrors(true);
      setErrors(response.data.errors);

      setTextAreaValue("");
      setProtocols([]);
      setPublicNote("");
      setPrivateNote("");
      setTabId("");
      return;
    } else {
      displaySuccess("Tickets tabulados com sucesso!");
      serIsErrors(false);
      setErrors([]);

      setTextAreaValue("");
      setProtocols([]);
      setPublicNote("");
      setPrivateNote("");
      setTabId("");
      return;
    }
  } catch (error: any) {
    displayError("Erro ao tabular tickets!");
    return;
  }
};
